module.exports = __webpack_public_path__ + "img/hero.cb27426.svg";